<template>
  <div class="filterbar filterbar-expanded" :class="[filterBarType, { 'hidden-secondary': !showFilterBar }]">
      <div class="inner-container">
        <div class="right-area">
            <slot name="right-bar"></slot>
        </div>
        <div class="filters-wrap">
          <div v-if="specialFilters.length > 0" class="calendar-area">
            <component 
              v-for="(filter_name, index) in specialFilters"
              :key="'special-' + index"
              :ref="'filter-item-' + filter_name"
              :is="filter_name"
              :filter-name="filter_name"
              v-model="getFilterConfig(filter_name).model"
              v-bind="getFilterConfig(filter_name).props"
            />
          </div>
          <div class="left-area">
            <component 
              v-for="(filter_name, index) in mainFilters"
              :key="'main-' + index"
              :ref="'filter-item-' + filter_name"
              :is="filter_name"
              :filter-name="filter_name"
              @filter-updated="filterUpdated"
              v-model="getFilterConfig(filter_name).model"
              v-bind="getFilterConfig(filter_name).props"
            />
            <div v-if="secondaryFilters && secondaryFilters.length > 0" class="filterbar-item filterbar-toggle" :class="{ selected: showFilterBar }">
              <div id="open_filters" class="filterbar-item-button filter-toggle">
                <button type="button" @click="showFilterBar = !showFilterBar" class="btn button-no-shadows">
                  <svg class="fa" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8.369 9.75l-3.846-5h11.86l-4.231 5H8.369zm.38 1.5h3v4.263l-3 1.333V11.25zM3.025 5.262l4.226 5.493v6.476c0 .904.93 1.51 1.757 1.142l3.5-1.556c.452-.2.743-.648.743-1.142v-4.9l4.626-5.468c.687-.812.11-2.057-.954-2.057H4.015c-1.037 0-1.623 1.19-.99 2.012zM18.75 11a.75.75 0 00-1.5 0v1.25H16a.75.75 0 000 1.5h1.25V15a.75.75 0 001.5 0v-1.25H20a.75.75 0 000-1.5h-1.25V11z" fill="currentColor" />
                  </svg>
                  <!-- <font-awesome-icon icon="fa-solid fa-filter" style="font-size: 16px;" /> -->
                   <div v-if="(activeFilters.length > 0)" class="filter-count-divider">
                    <span class="text-brand count">{{ activeFilters.length }}</span>
                   </div>
                </button>
              </div>
            </div>
            <div v-if="(activeFilters.length > 0) && showClearBtn" class="filterbar-item clear-filters">
              <span @click="clearAllFilters">
                <font-awesome-icon aria-hidden="true" icon="fa-solid fa-circle-xmark" />
                {{ $gettext('Clear') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="secondary-filters" :class="{ hidden: !showFilterBar }">
        <component 
          v-for="(filter_name, index) in secondaryFilters"
          :key="'secondary-' + index"
          :ref="'filter-item-' + filter_name"
          :filter-name="filter_name"
          :is="filter_name"
          @filter-updated="filterUpdated"
          v-model="getFilterConfig(filter_name).model"
          v-bind="getFilterConfig(filter_name).props"
        />
      </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  export default {
    name: "FilterBar",
    props: {
      cookieName: String,
      filterBarType: {
        type: String,
        default: ''
      },
      mainFilters: {
        type: Array,
        default: () => []
      },
      secondaryFilters: {
        type: Array,
        default: () => []
      },
      specialFilters: {
        type: Array,
        default: () => []
      },
      skipCookies: {
        type: String,
        default: null
      }
    },
    components: {
      CalendarNavigation: () => import('@/components/list_filters/CalendarNavigation'),
      CalendarViewSelector: () => import('@/components/list_filters/CalendarViewSelector'),
      UserFilter: () => import('@/components/list_filters/UserFilter'),
      DateRangeFilter: () => import('@/components/list_filters/DateRangeFilter'),
      CostCustomerFilter: () => import('@/components/list_filters/CostCustomerFilter'),
      CostSupplierFilter: () => import('@/components/list_filters/CostSupplierFilter'),
      CostTransactionFilter: () => import('@/components/list_filters/CostTransactionFilter'),
      CostTypeFilter: () => import('@/components/list_filters/CostTypeFilter'),
      VatFilter: () => import('@/components/list_filters/VatFilter'),
      CostStatusFilter: () => import('@/components/list_filters/CostStatusFilter'),
      SearchFilter: () => import('@/components/list_filters/SearchFilter'),
      HourStatusFilter: () => import('@/components/list_filters/HourStatusFilter'),
      HoursCustomerFilter: () => import('@/components/list_filters/HoursCustomerFilter'),
      ActiveHoursSelector: () => import('@/components/list_filters/ActiveHoursSelector'),
      HoursSorting: () => import('@/components/list_filters/HoursSorting'),
      ContactTypeFilter: () => import('@/components/list_filters/ContactTypeFilter'),
      ContactActiveFilter: () => import('@/components/list_filters/ContactActiveFilter'),
      TripCustomerFilter: () => import('@/components/list_filters/TripCustomerFilter'),
      ContactSorting: () => import('@/components/list_filters/ContactSorting'),
      TripTypeFilter: () => import('@/components/list_filters/TripTypeFilter'),
      TransportTypeFilter: () => import('@/components/list_filters/TransportTypeFilter'),
      BalanceSheetSorting: () => import('@/components/list_filters/BalanceSheetSorting'),
      TransactionTypeFilter: () => import('@/components/list_filters/TransactionTypeFilter'),
      TransactionAmountFilter: () => import('@/components/list_filters/TransactionAmountFilter'),
      InvoicesStatusFilter: () => import('@/components/list_filters/InvoicesStatusFilter'),
      InvoicesCustomerFilter: () => import('@/components/list_filters/InvoicesCustomerFilter'),
      DocumentTypeFilter: () => import('@/components/list_filters/DocumentTypeFilter'),
      ImportCustomerFilter: () => import('@/components/list_filters/ImportCustomerFilter'),
      ImportHoursProjectFilter: () => import('@/components/list_filters/ImportHoursProjectFilter'),
      QuotationsStatusFilter: () => import('@/components/list_filters/QuotationsStatusFilter'),
      QuotationsCustomerFilter: () => import('@/components/list_filters/QuotationsCustomerFilter'),
      ProductYearSelector: () => import('@/components/list_filters/ProductYearSelector'),
      ProductFormatSelector: () => import('@/components/list_filters/ProductFormatSelector'),
      CustomerInsightReportSelector: () => import('@/components/list_filters/CustomerInsightReportSelector'),
      CashflowDateRangeSelector: () => import('@/components/list_filters/CashflowDateRangeSelector'),
      AccountantConnectionStatusFilter: () => import('@/components/list_filters/AccountantConnectionStatusFilter'),
      CostCategoriesYearSelector: () => import('@/components/list_filters/CostCategoriesYearSelector')
    },
    data () {
      return {
        closeFlag: false,
        filters: false,
        unsubscribe: null,
        mutationName: '', //SET_REFRESH_FILTERED
        activeFilters: [],
        showFilterBar: false,
        ignoreMutations: false,
        showClearBtn: false
      }
    },
    created (){
      this.showFilterBar = false
      
      switch (this.filterBarType) {
        case 'costs':
          this.mutationName = 'SET_UPDATE_FILTER_COSTS'
          break;
        case 'contacts':
          this.mutationName = 'SET_UPDATE_FILTER_CONTACTS'
          break;
        case 'hours':
          this.mutationName = 'SET_UPDATE_FILTER_HOURS'
          break;
        case 'trips':
          this.mutationName = 'SET_UPDATE_FILTER_TRIPS'
          break;
        case 'balance_sheet':
          this.mutationName = 'SET_UPDATE_FILTER_BALANCE_SHEET'
          break;
        case 'bank':
          this.mutationName = 'SET_UPDATE_FILTER_BANK'
          break;
        case 'invoices':
          this.mutationName = 'SET_UPDATE_FILTER_INVOICES'
          break;
        case 'quotations':
          this.mutationName = 'SET_UPDATE_FILTER_QUOTATIONS'
          break;
        case 'documents':
          this.mutationName = 'SET_UPDATE_FILTER_DOCUMENTS'
          break;
        case 'products':
          this.mutationName = 'SET_UPDATE_FILTER_PRODUCTS'
          break;
        case 'hours-report':
          this.mutationName = 'SET_UPDATE_FILTER_HOURS_REPORT'
          break;
        case 'accountant-connections':
          this.mutationName = 'SET_UPDATE_FILTER_ACCOUNTANTS'
          break;
        case 'customer-insight':
          this.mutationName = 'SET_UPDATE_FILTER_CUSTOMER_INSIGHT'
          break;
        case 'cash-flow':
          this.mutationName = 'SET_UPDATE_FILTER_CASH_FLOW'
          break;
        case 'supplier-insight':
          this.mutationName = 'SET_UPDATE_FILTER_SUPPLIER_INSIGHT'
          break;
        case 'cost-categories':
          this.mutationName = 'SET_UPDATE_FILTER_COST_CATEGORIES'
          break;
      }

      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'filterStore/' + this.mutationName && !this.ignoreMutations) {
          this.filters = state["filterStore"].filter
          this.filtersChanged()
        }
        if(mutation.type === 'filterStore/SET_START_END_DATE'){
          if (state.filterStore.cookieName === 'TempReconFilterOptionsVue2-' + window.company_id) return
          if (state.filterStore.cookieName === 'costs-TempImportFilterOptionsVue2-' + window.company_id) return
          if (state.filterStore.cookieName === 'hours-TempImportFilterOptionsVue2-' + window.company_id) return
          if (state.filterStore.cookieName === 'trips-TempImportFilterOptionsVue2-' + window.company_id) return
          if (state.filterStore.cookieName === 'products-TempImportFilterOptionsVue2-' + window.company_id) return
          this.setCookies()
        }
        if(mutation.type === 'filterStore/SET_COOKIES'){
          this.setCookies()
        }
      });

      let filterCookieName = this.cookieName + '-' + window.company_id
      this.setCookienameAndReadCookie(filterCookieName)
      this.filters = this.$store.getters['filterStore/getFilter']

      // first load always filtering
      this.$store.commit("filterStore/" + this.mutationName)
    },
    destroyed () {
      this.unsubscribe()
    },
    methods: {
      ...mapActions({
        setCookienameAndReadCookie: "filterStore/setCookienameAndReadCookie",
      }),
      reloadFilterStore () {
        this.setCookienameAndReadCookie(this.cookieName + '-' + window.company_id)
      },
      clearAllFilters () {
        this.ignoreMutations = true
        // const allFilters = this.mainFilters.concat(this.secondaryFilters)
        this.mainFilters.concat(this.secondaryFilters).forEach(filter_name => {
          if (this.activeFilters.includes(this.$refs['filter-item-' + filter_name][0].$options.name)) {
            this.$refs['filter-item-' + filter_name][0].resetFilter()
          }
        })
        this.ignoreMutations = false
        this.$store.commit("filterStore/" + this.mutationName);
        this.showFilterBar = false
      },
      filterUpdated (payload) {
        if (!this.activeFilters.includes(payload.name) && payload.value) {
          this.activeFilters.push(payload.name)
          // show filterbar only if the active filter is secondary
          if (!this.isMainFilter(payload.name)) {
            this.showFilterBar = true
          } 
        } else if (!payload.value) {
          this.activeFilters = this.activeFilters.filter((item) => {
            return item !== payload.name
          })
        }
      },
      isMainFilter (filter_name) {
        return this.mainFilters.includes(filter_name)
      },
      filtersChanged () {
        this.setCookies()
        this.$emit('change', this.filters)
      },
      setCookies () {
        if (this.skipCookies) return
        var filter = this.$store.getters['filterStore/getFilter'];
        let filterCookieName = this.cookieName + '-' + window.company_id;
        var d1 = new Date (), expire = new Date ( d1 );
        expire.setMinutes ( d1.getMinutes() + 60 * 12 );
        this.$cookies.set(filterCookieName, filter, expire, '/');
      },
      showFilter (filter_name){
        if(this.specialFilters.includes(filter_name)){
          return true
        }
        return false;
      },
      getFilterConfig (filter_name) {
        const filterConfig = {
          CalendarNavigation: { model: null },
          CalendarViewSelector: { model: this.filters.activeView },
          SearchFilter: { model: this.filters.search },
          DateRangeFilter: { model: this.filters.option, props: { type: this.filterBarType } },
          CostCustomerFilter: { model: this.filters },
          CostSupplierFilter: { model: this.filters },
          CostTransactionFilter: { model: this.filters.payment_type },
          UserFilter: { model: this.filters.created_by },
          ContactTypeFilter: { model: this.filters.contact_type },
          ContactActiveFilter: { model: this.filters.is_archived },
          TripCustomerFilter: { model: this.filters },
          TripTypeFilter: { model: this.filters.type },
          TransportTypeFilter: { model: this.filters.transport_type, props: { car: this.filters.car } },
          HoursCustomerFilter: { model: this.filters },
          ActiveHoursSelector: { model: this.filters.exclude_archived },
          HoursSorting: { model: this.filters.ordering },
          HourStatusFilter: { model: this.filters.status },
          CostTypeFilter: { model: this.filters.cost_type },
          VatFilter: { model: this.filters },
          CostStatusFilter: { model: this.filters.status },
          ContactSorting: { model: this.filters.ordering },
          BalanceSheetSorting: { model: this.filters.balance_sheet_ordering },
          TransactionTypeFilter: { model: this.filters.status },
          TransactionAmountFilter: { model: this.filters.amount_type },
          InvoicesStatusFilter: { model: this.filters.status },
          InvoicesCustomerFilter: { model: this.filters },
          DocumentTypeFilter: { model: this.filters.type },
          ImportCustomerFilter: { model: this.filters.importCostCustomer },
          ImportHoursProjectFilter: { model: this.filters.project },
          QuotationsStatusFilter: {model: this.filters.status},
          QuotationsCustomerFilter: {model: this.filters},
          ProductYearSelector: { model: this.filters.product_year },
          ProductFormatSelector: { model: this.filters.product_format },
          AccountantConnectionStatusFilter: { model: this.filters.status },
          CustomerInsightReportSelector: {model: this.filters.report_option },
          CashflowDateRangeSelector: { model: this.filters.cashflow_options },
          CostCategoriesYearSelector: { model: this.filters.cost_categories_year }
        }
        return filterConfig[filter_name]
      }
    }
  };
</script>

<style lang="scss">
.filterbar { 
  display: flex;
  flex-direction: column;
  &.hidden-secondary { 
    .inner-container {
      padding-bottom: 0;
      border-bottom: 0px solid $colorBorderDash;
    }
  }
  &.no-totals {
    .inner-container {
      min-height: 30px;
    }
  }
  .inner-container {
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: space-between;

    gap: 0.5rem;

    color: $colorTextBase;
    border: none;

    padding-bottom: 0.5rem;
    border-bottom: 1px solid $colorBorderDash;
    margin-bottom: 0.5rem;

    min-height: 34px; // fix for alignment with totalamounts comp.
    .calendar-area {
      display:flex;
      flex: 1 1 auto;
    }
    .filters-wrap,
    .left-area,
    .right-area {
      display:flex;
      flex: 1 1 auto;
      align-items: flex-end;
      flex-flow: row wrap;
    }
    .filters-wrap {
      justify-content: space-between;
      position: relative;
      order: 0;
      width: auto;
      padding: 0;
      border: 0;
    }
    .left-area {
      justify-content: flex-start;
      position: relative;
      order: 1;
      margin-top: 10px;
      gap: 0.5rem;
    }
    .right-area {
      order: 1;
      flex-grow: 0;
    }
    @media (min-width: '992px') {
      .left-area {
        margin-top: 0px;
      }
    }
  }
  .secondary-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    &.hidden {
      display: none;
    }
    .filterbar-item {
      // margin-bottom: 0.5rem;
    }
  }
  &.hours {
    .left-area {
      flex: 0 1 auto;
    }
    .right-area {
      flex: 0 1 auto;
    }
    @media( max-width: '450px' ){
      .filters-wrap {
        .calendar-area {
          margin-bottom: 5px; 
          flex-direction: column; 
          order: 2;
          .view-selector {
            width: 100%;
            margin-bottom: 10px;
            margin-right: 0px;
            .filterbar-item { width: 33%; border-bottom: 2px solid #dddddd; }
          }
          .cal-navigation { justify-content: center; }
        }
      }
    }
  }
}
.filterbar-item {
  max-width: 150px;
  white-space: nowrap;
  height: $filterHeight;
  // &:not(:last-child) { margin-right: 0.5rem; }
  margin: 1px; // to prevent box-shadow overflow
  &.clear-filters {
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    cursor: pointer;
    color: #808080;
    font-size: 14px;
    &:hover {
      color: $colorUnassigned;
    }
    span {
      display: flex;
      align-items: center;
    }
    svg { margin-right: 0.15rem; font-size: 12px; }
  }

  .button-no-shadows {
    // height: 24px;
    padding: 0;
    // max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &:not(:disabled):not(.disabled), &:focus, .focus {
      box-shadow: none !important;
    }
  }
  .dropdown-menu { margin-top: 0.5rem; }
  .dropdown-menu, .dropdown-toggle{
    font-size: $filtersTextSize;
  }
  .dropdown-toggle:after {
    color: $colorBlue;
    position: absolute;
    right: 8px;
    margin-top: 1px;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
  }
 
  &.item-search {
    border: $filtersBorderSize solid #dfe1e6;
    background: #fafbfc;
    input { font-size: $filtersTextSize; }
  }

  &--expanded {
    max-width: none;
    .button-no-shadows {
      max-width: none;
    }
  }

  .filterbar-item-button {
    width: 100%;
    text-overflow: ellipsis;
    display: block;
    position: relative;

    padding: 2px 0;
    // padding-left: 7px;
    margin: 0;
    button { 
      padding-right: 1.5rem;
      padding-left: 0.5rem;
      color: $colorTextBase;
      border: 0;
      border-radius: 0;
      &.dropdown-toggle:after {
        right: 0.5rem;
      }
    }
    &.filter-toggle {
      padding: 2px 7px;
      .fa { width: 22px; height: 22px; }
      .btn {
        display: flex;
        align-items: center;
        font-size: $filtersTextSize !important;
        padding: 0;
      }
    }
    .dropdown-item {
      padding-left: 10px;
      padding-top: 3px;
      padding-bottom: 3px;
      .fa, .emoji { margin-right: 5px; }
    }
  }
  .btn-filter {
    background-color: rgba(34, 172, 138, 0);
    color: #8D8D8D;
    border-bottom: 2px solid transparent;
    border-radius: 0;
    padding: 0 10px;
    &:hover {
      color: $colorTextBase;
      background-color: rgba(34, 172, 138, 0.0);
    }
  }
  &.selected {
    border-bottom: 2px solid $colorBrand;
    .btn-filter {
      color: $colorTextBase;
    }
  }
  &.filterbar-toggle {
    // border-radius: $radiusXl !important;
    &:not(.selected) {
      background: transparent;
      border-color: transparent !important;
      button { color: $colorTextBase; }
    }
    &:hover {
      border-color: transparent !important;
    }
    &.selected:hover {
      background: $colorBrand50;
      border-color: $colorBrand !important;
      button { color: $colorBrand800; }
    }
    .filter-count-divider {
      box-shadow: inset 1px 0 $colorBorderDash;
      margin-left: 0.5rem;
      padding-left: 0.5rem;
      .count {
        font-family: 'DINNextLTPro-Medium';
      }
    }
  }
  .reset-filter {
    color: $colorBrand;
    padding-right: 0.5rem;
    cursor: pointer;
    transition: color 0.2s ease;
    &:hover {
      color: $colorBrand800;
    }
  }
}

.filterbar-expanded {
  .filterbar-item:not(.cal-navigation):not(.cal-filter) {
    max-width: none;
    background: white;
    border: $filtersBorderSize solid $colorBorderDash;
    transition: background-color 200ms ease-in-out 0s, border-color 200ms ease-in-out 0s;
    border-radius: $radiusSm;

    display: flex;
    align-items: center;

    box-shadow: $filtersShadow;
 
    &:not(.selected):hover {
      background: $colorBrand50;
      border: $filtersBorderSize solid $colorBrand;
      .filterbar-item-button {
        button {
          color: $colorBrand800; 
          &.dropdown-toggle:after {
            color: $colorBrand;
          }
        }
      }
    }
    &.selected {
      border: $filtersBorderSize solid $colorBrand;
      background: $colorBrand50;
      &.item-search {
        background: $colorBrand50 !important;
        border-color: $colorBrand;
        input { color: $colorBrand; }
        .fa { color: $colorBrand; }
        .reset-filter { color: $colorBrand; }
      }
      .filterbar-item-button {
        button {
          color: $colorBrand800; 
          &.dropdown-toggle:after {
            color: $colorBrand;
          }
        }
      }
    }
  }
}
</style>